import { AttributionType } from '../campaign.model';
import { Widget, WidgetLayout, WidgetPreviewImage } from '../widgets.model';

export interface CampaignTemplate {
  id: number;
  accountId?: number;
  name?: string;
  nameSwedish?: string;
  templateId?: number;
  widgets?: Array<Widget>;
  tagsDetails?: Array<TemplateTag>;
  statistics?: TemplateStatistics;
  previewImages?: WidgetPreviewImage[];
  status?: TemplateStatus;
  scheduling?: TemplateScheduling;
  urlSettings?: TemplateUrlSetting[];
  triggers?: TemplateTrigger[];
  conditions?: TemplateCondition[];
  lastPublished?: Date;
  layout?: WidgetLayout;
  numberOfUsages?: number;
  hasInputFields?: boolean;
  order?: number;
  attributionType?: AttributionType;
  author?: CampaignTemplateAuthor;
  descriptionItems?: CampaignTemplateDescriptionItems;
  objectives?: string[];
  tactics?: string[];
}

export interface CampaignTemplateDescriptionItems {
  items: string[];
  itemsSwedish: string[];
}

export interface CreateOrUpdateCampaignTemplate {
  name: string;
  nameSwedish?: string;
  layout: WidgetLayout;
  author: CampaignTemplateAuthor;
}

export interface CampaignTemplateAuthor {
  name?: string;
  image?: string;
  url?: string;
}

export interface TemplateTag {
  id: number;
  name: string;
  color?: string;
  type?: WidgetTemplateTagType;
  // Only for client
  icon?: string;
}

export enum WidgetTemplateTagType {
  Regular = 'Regular',
  Layout = 'Layout',
  Purpose = 'Purpose',
  Content = 'Content',
  Event = 'Event',
  View = 'View',
  CampaignType = 'CampaignType',
}

export enum TemplateType {
  Promotion = 'promotion',
  Form = 'form',
  Survey = 'survey',
  Promotions = 'promotions',
  Forms = 'forms',
  Surveys = 'surveys',
  Referral = 'referral',
  Games = 'games',
  Quiz = 'quiz',
  NudgeTour = 'nudge-tour',
}

export enum TemplateTypeForNewCategories {
  Games = 'games',
  Game = 'game',
  Quiz = 'quiz',
  ProductTours = 'product-tours',
  ProductTour = 'product-tour',
  Nudge = 'nudge',
}

export enum ViewTemplateTags {
  Themed = 'themed',
  Basic = 'basic',
  Blank = 'blank',
}

export interface TemplateUrlSetting {
  id: number;
  path: string;
  isPathTypeInclude: boolean; // False is for exclude
}

export interface TemplateTrigger {
  id: number;
  type: TemplateTriggerType;
  value: string;
}

export interface TemplateCondition {
  id: number;
  type: TemplateConditionType;
  value?: string;
  show: boolean;
}

export enum TemplateTriggerType {
  Instantly = 'Instantly',
  AfterXPageviews = 'AfterXPageviews',
  AfterXSeconds = 'AfterXSeconds',
  ExitIntent = 'ExitIntent',
  Scroll = 'Scroll',
  InactiveForXSeconds = 'InactiveForXSeconds',
  Manual = 'Manual',
}

export enum TemplateConditionType {
  IdentifiedUser = 'IdentifiedUser',
  QueryParam = 'QueryParam',
  Device = 'Device',
  Cookie = 'Cookie',
}

export interface TemplateScheduling {
  id: number;
  startAndEndDateEnabled?: boolean;
  startDate?: Date;
  endDate?: Date;
  customDaysAndHoursEnabled?: boolean;
  customDays?: string[];
  customHours?: number[];
}

export enum TemplateStatus {
  Draft = 'Draft',
  Published = 'Published',
  Unpublished = 'Unpublished',
}

export enum TemplateLanguage {
  English = 'English',
  Swedish = 'Swedish',
}

export class TemplateStatistics {
  used: number;
  conversionRate: number;
  conversions: number;

  constructor(used: number, conversions: number) {
    this.used = used;
    this.conversions = conversions;

    if (this.conversions && this.used && this.used !== 0) {
      if (this.conversions !== 0) {
        this.conversionRate = (this.conversions / this.used) * 100;
      } else {
        this.conversionRate = 0;
      }
    }
  }
}

export interface BrandVariablesUsage {
  campaignId: number;
  campaignName: string;
  totalComponents: number;
  componentsNotFixed: number;
}
